import { Outlet } from 'react-router-dom';
import {
  IconNavArchiveBox,
  IconNavCalendarDays,
  IconNavCog,
  IconNavPresentationChartLine,
} from '../../components/icons';
import { AppShellGrid, type NavEntry } from '../../components/Sidebar';
import { useDict } from '../../i18n/dictionary';
import { useAppCrumb } from '../../layouts/AppLayout';
import { caloriesDict } from './i18n';

export function CaloriesLayout() {
  const t = useDict(caloriesDict);
  useAppCrumb('calories', t.appName, '/calories');
  /** A past day is reached from the day view's arrows, so Today stays lit. */
  const nav: NavEntry[] = [
    {
      key: 'today',
      href: '/calories',
      label: t.today,
      icon: IconNavCalendarDays,
      end: true,
      activeOn: ['/calories/days/:date'],
    },
    {
      key: 'products',
      href: '/calories/products',
      label: t.products,
      icon: IconNavArchiveBox,
      activeOn: ['/calories/dishes'],
    },
    {
      key: 'progress',
      href: '/calories/progress',
      label: t.progress,
      icon: IconNavPresentationChartLine,
    },
    {
      key: 'settings',
      href: '/calories/settings',
      label: t.settings,
      icon: IconNavCog,
    },
  ];
  return (
    <AppShellGrid items={nav}>
      <Outlet />
    </AppShellGrid>
  );
}
